// extracted by mini-css-extract-plugin
export default {"table":"hxnL92x2lWsTtja3KamZ","emptyMessage":"zlM8Jbin7IsCLTVHLi7h","emptyButtonContainer":"HxhKATBaenoFhWfmVNWo"};